module.exports = __webpack_public_path__ + "img/tool_active.5c0f4acf.svg";